export default (state = [], action) => {
  switch (action.type) {
    case 'REGIONS_DATA:SUCCESS': {
      return {
        ...state,
        councilsData: action.payload,
      };
    }
    case 'REGIONS_QLD_GEO:SUCCESS': {
      return {
        ...state,
        qldCouncilsGeo: action.payload,
      };
    }
    case 'WATER_DATA:SUCCESS': {
      return {
        ...state,
        regions: action.payload.regions,
        entities: action.payload.entities,
        dams: action.payload.dams,
      }
    }

    default: {
      return state;
    }
  }
};

export const getCouncilsData = state => state.councilsData;
export const getRegionsData = state => state.regions;
export const getDamsData = state => state.dams;
export const getQldCouncilsGeo = state => state.qldCouncilsGeo;



// WEBPACK FOOTER //
// ./src/reducers/regions.js